const getters = {
  user: state => state.user.user,
  user_info: state => state.user.user_info,
  site: state => state.user.site,
  advert: state => state.user.advert,
  copyright_lst: state => state.user.copyright_lst,
  config: state => state.user.config,
  manystore: state => state.user.manystore,
  helpList: state => state.common.helpList,
  goodsList: state => state.common.goodsList,
  noticeList: state => state.common.noticeList,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js